import React from 'react';

function AboutPage() {
  return (
    <div className="about-page">
      <h1>About Us</h1>
      <p>We are a team of developers dedicated to creating awesome web applications.</p>
    </div>
  );
}

export default AboutPage;
